angular.module('LeasePilot').factory('BlankLeaseService', [
  'railsResourceFactory',
  function(railsResourceFactory) {
    return railsResourceFactory({
      url: '/api/blank_leases',
      name: 'blankLeases',
    });
  },
]);
